export const Paths = {
  search: { url: "/" },
  detailsPage: { url: "/items/:itemId+" },
  checkout: { url: "/checkout" },
  confirmation: { url: "/confirmation" },
  orders: { url: "/orders" },
  lcrOrderTracking: { url: "/orders/lcr/:serialNumber" },
  amznhamOrderTracking: { url: "/orders/amznham/:orderId" },
  myHardware: { url: "/my-hardware" },
  replacement: { url: "/replacement/:assetTag" },
  campaigns: { url: "/campaigns" },
  sessionExpired: { url: "/session-expired" },
  notFound: { url: "*" },
} as const;

export const buildPath = (pattern: string, params: Record<string, string>): string =>
  Object.entries(params).reduce(
    (url, [key, value]) => url.replace(`:${key}`, encodeURIComponent(value)),
    pattern
  );
